// extracted by mini-css-extract-plugin
export default {"contentStudios":"mainStudios_contentStudios__gO9uC"};